import { useEffect } from "react";
import { Box, Typography, Card } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "@/store";
import { fetchFiles } from "@/store/filesSlice";
import { FileTable } from "@components/FileTable";
import { PageContainer } from "@components/PageContainer";

export default function MyFiles() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { files } = useAppSelector((s) => s.files);

  useEffect(() => {
    dispatch(fetchFiles({ limit: 100 }));
  }, [dispatch]);

  return (
    <PageContainer>
      <Typography
        variant="h5"
        sx={{
          fontWeight: "bold",
          mb: 3,
        }}
      >
        {t("nav.myFiles")}
      </Typography>
      <Card>
        <FileTable files={files} />
      </Card>
    </PageContainer>
  );
}
